import { render, staticRenderFns } from "./AdminSetting.vue?vue&type=template&id=5188b402"
import script from "./AdminSetting.vue?vue&type=script&lang=js"
export * from "./AdminSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports